module.exports = __webpack_public_path__ + "static/media/Board_2@2x.4ed7becb.png";